import React from 'react';
import PropTypes from 'prop-types';
import './TodoItem.css';

class TodoItem extends React.Component{

    // Méthodes:
    listCheckedStyle = () => {
        return {
            textDecoration: this.props.todo.completed ? 'line-through' : 'none'
        }
    }

    listCheckedStyle2 = () => {
        return {
            backgroundColor: this.props.todo.completed ? 'rgba(255,255,255,0.5)' : 'transparent',
            borderLeft: this.props.todo.completed ? 'none' : 'solid 1px #ccc',
            borderBottom: this.props.todo.completed ? 'none' : 'solid 1px #ccc',
            color: this.props.todo.completed ? 'rgba(0,0,0,0.7)' : '#ccc'
        }
    }

    // Render:
    render(){
        // Destructuring:
        const {id, title} = this.props.todo;

        return(
            <div className="conteneur_global">
                <div className="conteneur_item" style={this.listCheckedStyle2()}>
                    <input type="checkbox" title="Marquer cette tâche" onChange={this.props.changeCompletedState.bind(this, id)} />
                    <p style={this.listCheckedStyle()}>{title}</p>
                </div>
                <div className="conteneur_supItem" title="Supprimer cette tâche" onClick={this.props.delTodo.bind(this, id)}><span>X</span></div>
            </div>
        );
    }

}

// PropTypes:
TodoItem.prototypes = {
    todo: PropTypes.object.isRequired
};

export default TodoItem;